<wbo-edit-page #editPage [title]="model.data.name" [formGroup]="editPage.formGroup">
    <fui-formation-group-template
        *formationGroup="{title: 'wbo.docket-selector.edit.formation.details', formControlNames: ''}">
        <fui-rows>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-text-edit-control formControlName="name" [(ngModel)]="model.data.name"></wbo-text-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
        </fui-rows>
    </fui-formation-group-template>
</wbo-edit-page>
